module.exports = __webpack_public_path__ + "static/img/9_03.5d813550.png";